// Every time the route changes (fired on initialization too)
export default function ({ $axios, app }) {
  $axios.onError(async (error) => {
    // if from auth0 error & invalid grant then, properly logout and redirect to login
    if (
      error?.response?.config?.url.includes('auth0') &&
      error.response.data.error === 'invalid_grant'
    ) {
      console.error('[Auth Error] Invalid grant error:', error.response.data.error)
      
      try {
        // Properly logout to clear auth state
        await app.$auth.logout()
        
        // Clear Datadog RUM user session
        if (process.client) {
          const { datadogRum } = await import('@datadog/browser-rum')
          datadogRum.clearUser()
        }
      } catch (logoutError) {
        console.error('[Auth Error] Failed to logout:', logoutError)
        // Fallback: clear tokens manually
        try {
          await app.$auth.strategy?.token?.reset()
          
          // Clear Datadog RUM user session
          if (process.client) {
            const { datadogRum } = await import('@datadog/browser-rum')
            datadogRum.clearUser()
          }
        } catch (resetError) {
          console.error('[Auth Error] Failed to reset token:', resetError)
        }
      }
      
      // Redirect to login page instead of home to avoid redirect loops
      if (app.router.currentRoute.path !== '/auth/login/') {
        app.router.push('/auth/login/')
      }
    }
  })
}
